import React from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import linkToHome from 'util/misc/link-to-home';


function RootPage({ activeRegion }) {
    const query = document.location.search;
    return <Redirect to={`${ linkToHome(activeRegion) }${ query }`}/>;
}

RootPage.propTypes = {
    activeRegion: PropTypes.object,
};

export default connect(
    reduxUtils.mapStateToProps({
        activeRegion: 'region.active',
    }),
)(RootPage);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/templates/root/index.js